export default __webpack_public_path__ + "static/media/download-icon.7c393b8c.svg";